import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    ProductListWidgetContainer as SourceProductListWidgetContainer,
    mapDispatchToProps
} from 'SourceComponent/ProductListWidget/ProductListWidget.container';
import { getIndexedProducts } from 'Util/Product';
import { sortOutOfStockLast } from '../../util/Product/Product';
import ProductListQuery from 'Query/ProductList.query';

export class ProductListWidgetContainer extends SourceProductListWidgetContainer {
    static propTypes = {
        showPager: PropTypes.number,
        productsCount: PropTypes.number,
        productsPerPage: PropTypes.number,
        conditionsEncoded: PropTypes.string,
        updateNoMatch: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired,
        skuOrder: PropTypes.string,
    };

    static defaultProps = {
        showPager: 0,
        productsCount: 10,
        productsPerPage: 5,
        conditionsEncoded: null,
        skuOrder: null // Set a default value for custom_sort
    };

    updateProductListItems(data) {
        const { productsCount, productsPerPage, skuOrder } = this.props;
        const {
            products: {
                items,
                total_count: totalItems,
                page_info: { current_page } = {}
            } = {}
        } = data;

        const totalPages = Math.ceil(productsCount / productsPerPage);

        let orderedItems = [];
        if (skuOrder) {
            const skuOrderArray = skuOrder.split(','); // comma-separated string
            orderedItems = skuOrderArray
                .filter(sku => items.some(item => item.sku === sku))
                .map(sku => items.find(item => item.sku === sku));
        } else {
            orderedItems = items;
        }

        // Place out-of-stock items (using stock_status) at the end
        orderedItems = sortOutOfStockLast(orderedItems);

        this.setState({
            isLoading: false,
            totalItems,
            totalPages,
            pages: { [current_page]: getIndexedProducts(orderedItems) }
        });
    }

    requestProductList(options) {
        const { isNext } = options;
        // #FA-1406 hotfix;
        // TODO use configured sorting from category definition (in admin) instead of default top_seller_alt
        let optionsWithSort = { ...options};
        if (optionsWithSort) {
            optionsWithSort = {...optionsWithSort,
                args: {...optionsWithSort.args,
                    sort: {
                        sortKey: 'top_seller_alt',
                        sortDirection: 'DESC'
                    }}};
        }

        if (!isNext) {
            this.updateLoadStatus(true);
        }

        this.fetchData(
            [ProductListQuery.getQuery(optionsWithSort)],
            isNext ? this.appendPage : this.updateProductListItems,
            this.onError
        );
    }
}

export default connect(null, mapDispatchToProps)(ProductListWidgetContainer);
